import { render, staticRenderFns } from "./SidebarTableFieldsContainer.vue?vue&type=template&id=6712e107&scoped=true&"
import script from "./SidebarTableFieldsContainer.vue?vue&type=script&lang=ts&"
export * from "./SidebarTableFieldsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarTableFieldsContainer.vue?vue&type=style&index=0&id=6712e107&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6712e107",
  null
  
)

export default component.exports